import { render, staticRenderFns } from "./CreateTemplatePopupOld.vue?vue&type=template&id=c420e4ae&scoped=true"
import script from "./CreateTemplatePopupOld.vue?vue&type=script&lang=js"
export * from "./CreateTemplatePopupOld.vue?vue&type=script&lang=js"
import style0 from "./CreateTemplatePopupOld.vue?vue&type=style&index=0&id=c420e4ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c420e4ae",
  null
  
)

export default component.exports